import CommentReply from './CommentReply'
import withCommentReply from './withCommentReply'

const ConnectedCommentReply = withCommentReply(CommentReply)

export { ConnectedCommentReply as CommentReply }
